const NODE_ENV = "production";

const modes = {
    development: { URL: "http://188.166.84.192:9105", AUTH: "http://188.166.84.222:9100" },
    qa: { URL: "https://api2-qa.ishkuni.uz", AUTH: "https://api1-qa.ishkuni.uz" },
    production: { URL: "https://api2.ishkuni.uz", AUTH: "https://api.ishkunim.uz" },
};

// scp -r build root@159.223.217.246:/var/www/applicant
export default modes[NODE_ENV] || { URL: "http://188.166.84.192:9105", AUTH: "http://188.166.84.222:9100" };
